import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, CanActivate, Router, RouterStateSnapshot } from '@angular/router';
import { AuthenticationService } from '../_services/authentication.service';

@Injectable({
  providedIn: 'root'
})
export class AuthGuard implements CanActivate {
  roleUser: any;

  constructor(private authService: AuthenticationService, private router: Router) { }

  canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): boolean {
    this.roleUser = JSON.parse(localStorage.getItem('userRole') || '[]');

    const publicRoutes = ['login', 'forgot-password'];
    const urlSegments = state.url.split('/');
    const currentModule = urlSegments.length > 2 ? urlSegments[2] : null;
    const currentFunction = urlSegments.length > 3 ? urlSegments[3] : null;

    if (publicRoutes.includes(urlSegments[1])) {
      return true;
    }
    if (!this.authService.isAuthenticated()) {
      this.router.navigate(['login']);
      return false;
    }

    if (currentModule && !this.hasModulePermission(currentModule)) {
      if (currentModule === "profile" || currentModule === "helpdesk") {
        return true;
      }
      this.router.navigate(['forbidden']);
      return false;
    }
    if (currentFunction && !this.hasFunctionPermission(currentModule, currentFunction)) {
      if (currentFunction.includes("edit-employee") || currentFunction.includes("add-employee") || currentFunction.includes("view-profile") || currentFunction.includes("raise-ticket")) {
        return true;
      }
      this.router.navigate(['forbidden']);
      return false;
    }

    return true;
  }

  hasModulePermission(url: any): boolean {
    return this.roleUser.some((mod: any) => url.includes(mod.moduleUrl));
  }
  hasFunctionPermission(module: string | null, func: string): boolean {
    if (!module) return false;
    return this.roleUser.some((role: any) =>
      role.moduleUrl === module &&
      role.functions.some((f: any) => f.functionUrl.includes(func))
    );
  }
}

